import { endpoints } from "@/api/endpoints/endpoints";
import {
  createGoodRequest,
  deleteFulfillment,
  getFulfillment,
} from "@/api/fulfillment-api";
import { useCollectionData, useMutation } from "@/hooks/use-api";
import { toast } from "@/hooks/use-toast";

export function useGetFulfillment(id: string) {
  const cacheKey = endpoints.fulfillment.get(id);

  return useCollectionData(cacheKey, () => getFulfillment(id), {
    refreshInterval: 0,
    revalidateOnFocus: false,
  });
}

export function useDeleteFulfillment() {
  return useMutation(deleteFulfillment, {
    onSuccess: (response) => {
      console.log("Fulfillment deleted successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error deleting Fulfillment:", error);
    },
  });
}

export function useCreateGoodRequest() {
  return useMutation(createGoodRequest, {
    onSuccess: (response) => {
      console.log("Good request created successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error creating good request:", error);
    },
  });
}

export function useCreateGoodRequestAction(onReloadOrder?: () => void) {
  const createGoodRequestMutation = useCreateGoodRequest();

  const createGoodRequestForFulfillment = async (fulfillmentId: string) => {
    try {
      const resp = await createGoodRequestMutation.executeAsync(fulfillmentId);

      if (resp.success) {
        toast({
          title: "Success",
          description: "Good request created successfully",
        });
        onReloadOrder?.();
        return;
      }

      toast({
        title: "Error",
        description: resp.message || "Failed to create good request",
        variant: "destructive",
      });
    } catch (error) {
      toast({
        title: "Error",
        description:
          error instanceof Error ? error.message : "Failed to create good request",
        variant: "destructive",
      });
    }
  };

  return { createGoodRequestForFulfillment };
}
